/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import RankControllerDtoRankDetailSettingListResponse from '../model/RankControllerDtoRankDetailSettingListResponse';
import RankControllerDtoRankDetailSettingUpdateRequest from '../model/RankControllerDtoRankDetailSettingUpdateRequest';
import RankControllerDtoRankDetailSettingUpdateResponse from '../model/RankControllerDtoRankDetailSettingUpdateResponse';

/**
* PerplayRank service.
* @module api/PerplayRankApi
* @version 1.0
*/
export default class PerplayRankApi {

    /**
    * Constructs a new PerplayRankApi. 
    * @alias module:api/PerplayRankApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the apiPerplayRankRankDetailSettingListPost operation.
     * @callback module:api/PerplayRankApi~apiPerplayRankRankDetailSettingListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RankControllerDtoRankDetailSettingListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {module:api/PerplayRankApi~apiPerplayRankRankDetailSettingListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/RankControllerDtoRankDetailSettingListResponse}
     */
    apiPerplayRankRankDetailSettingListPost(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = [];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = RankControllerDtoRankDetailSettingListResponse;
      return this.apiClient.callApi(
        '/api/PerplayRank/RankDetailSettingList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayRankRankDetailSettingUpdatePost operation.
     * @callback module:api/PerplayRankApi~apiPerplayRankRankDetailSettingUpdatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RankControllerDtoRankDetailSettingUpdateResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/RankControllerDtoRankDetailSettingUpdateRequest} [rankControllerDtoRankDetailSettingUpdateRequest] 
     * @param {module:api/PerplayRankApi~apiPerplayRankRankDetailSettingUpdatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/RankControllerDtoRankDetailSettingUpdateResponse}
     */
    apiPerplayRankRankDetailSettingUpdatePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['rankControllerDtoRankDetailSettingUpdateRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = RankControllerDtoRankDetailSettingUpdateResponse;
      return this.apiClient.callApi(
        '/api/PerplayRank/RankDetailSettingUpdate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
